import styled from 'styled-components';

export const ChildTextRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 20px;

  polyline {
    color: #78797c;
  }
`;

export const ChildTextContent = styled.div`
  display: block;
  float: right;
  width: 100%;
  margin: 0 0 0 5px;
  color: #78797c;
  text-align: left;
  line-height: initial;
  font-size: 12px;
  font-weight: ${props => (!!props.bold ? '500' : '400')};

  white-space: pre-line;
  cursor: pointer;

  &:not(:first-of-type) {
    margin-bottom: 20px;
  }
`;
